import { Grid } from "@mui/material";
import { LabeledText } from "components/Typography/LabeledText";

interface Agency {
  mailingAddress?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  county?: string | null;
  phone?: string | null;
  email?: string | null;
}

interface AgencyDetailsProps {
  agency: Agency | null;
}

export const AgencyDetails: React.FC<AgencyDetailsProps> = ({ agency }) => {
  if (!agency) return null;

  return (
    <>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {/* Row 1: Street Address, City, Phone */}
        <Grid size={4}>
          <LabeledText label="Street Address" value={agency?.mailingAddress} />
        </Grid>
        <Grid size={4}>
          <LabeledText label="City" value={agency?.city} />
        </Grid>
        <Grid size={4}>
          <LabeledText label="Phone" value={agency?.phone} />
        </Grid>

        {/* Row 2: State, Zip, County */}
        <Grid size={4}>
          <LabeledText label="State/Territory" value={agency?.state} />
        </Grid>
        <Grid size={4}>
          <LabeledText label="Zip" value={agency?.zip} />
        </Grid>
        <Grid size={4}>
          <LabeledText label="County" value={agency?.county} />
        </Grid>

        {/* Row 3: Email */}
        <Grid size={12}>
          <LabeledText label="Email" value={agency?.email} />
        </Grid>
      </Grid>
    </>
  );
};
